var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TariffOptionsWithoutCategory',{attrs:{"analyticFlowType":_vm.AnalyticServiceTypeKeys.tel,"pageDescription":_vm.$t('message.tariffOptions.descriptionFixTel'),"products":_vm.products,"serviceType":_vm.fixedKey}})}
var staticRenderFns = []

export { render, staticRenderFns }